<template>
  <div class="product-cart-account">
    <a class="product-cart-link" :href="href">
      <svg class="icon">
        <title>Account</title>
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#account"></use>
      </svg>
      <span v-if="!!username">{{ name }}</span>
    </a>
  </div>
</template>

<script>
import vtex from '../../api/vtex';
import { createURLSearchParams, readURLSearchParams } from '../../utilities/url';

export default {
  name: 'product-cart-account',
  props: {
    nameTemplate: {
      type: String,
      required: true,
    },
    authUrl: {
      type: String,
      required: true,
    },
    userinfoUrl: {
      type: String,
      required: true,
    },
    profileUrl: {
      type: String,
      required: true,
    },
    redirectUrl: {
      type: String,
      required: true,
    },
    clientId: {
      type: String,
      required: true,
    },
    saltValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      email: '',
      username: '',
    };
  },
  computed: {
    isLoggedIn() {
      return !!this.email;
    },
    href() {
      if (this.isLoggedIn) {
        return this.profileUrl;
      }

      return `${this.authUrl}?${createURLSearchParams({
        client_id: this.clientId,
        redirect_uri: this.redirectUrl,
        scope: 'user_info',
        state: 'try_sample_request',
        include_granted_scopes: 'true',
        response_type: 'token',
      })}`;
    },
    name() {
      return this.supplant(this.nameTemplate, {
        name: this.username,
      });
    },
  },
  created() {
    this.setUserData();
  },
  methods: {
    getAuthAccessToken() {
      const query = readURLSearchParams(window.location.search);

      let token = '';

      if (query.access_token) {
        token = query.access_token;
      } else {
        token = localStorage.getItem('access_token');
      }

      localStorage.setItem('access_token', token);

      return token;
    },
    setUserData() {
      const token = this.getAuthAccessToken();

      if (!token) {
        localStorage.setItem('user_data', '');
        return;
      }

      vtex
        .getUserName(this.userinfoUrl, token)
        .then((data) => {
          this.email = data.email;
          this.username = data.username;
          const text = this.email + this.saltValue;
          this.digestMessage(text).then((digestHex) => {
            let testObject = { email: digestHex, userId: data.userId };
            localStorage.setItem('user_data', JSON.stringify(testObject));
          });
          let aValue = JSON.parse(localStorage.getItem('user_data'));
          dataLayer.forEach((el) => {
            if (aValue) {
              if (el.uiEmailId && aValue.email) {
                el['uiEmailId'] = aValue.email;
              }
              if (el.uiUser && aValue.userId) {
                el['uiUser'] = aValue.userId;
              }
            } else {
              delete el['uiEmailId'];
              delete el['uiUser'];
            }
          });
          this.$forceUpdate();
        })
        .catch(() => {
          localStorage.setItem('access_token', '');
          localStorage.setItem('user_data', '');
        });
    },
    async digestMessage(message) {
      const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
      const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8); // hash the message
      const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
      const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
      return hashHex;
    },
    supplant(template, data) {
      return `${template}`.replace(/{([^{}]*)}/g, (value, index) => data[index]);
    },
  },
};
</script>
